var React = require('react');

function SocialMediumInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.8061 13.728C10.8376 13.4264 10.7189 13.1284 10.4865 12.9255L8.11959 10.1627V9.75H15.469L21.1496 21.8214L26.1439 9.75H33.15V10.1627L31.1263 12.0428C30.9518 12.1716 30.8653 12.3834 30.9015 12.593V26.407C30.8653 26.6166 30.9518 26.8284 31.1263 26.9572L33.1027 28.8373V29.25H23.1615V28.8373L25.2089 26.9114C25.4101 26.7165 25.4101 26.6592 25.4101 26.3611V15.1953L19.7176 29.2041H18.9484L12.3209 15.1953V24.5842C12.2657 24.979 12.401 25.3764 12.6878 25.6618L15.3506 28.7914V29.2041H7.80005V28.7914L10.4629 25.6618C10.7476 25.3759 10.875 24.9758 10.8061 24.5842V13.728Z","fill":"white"}));
}

SocialMediumInline.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = SocialMediumInline;

SocialMediumInline.default = SocialMediumInline;
